import React from "react";
import { Scissors, Wheat, Trees, Wrench } from "lucide-react";
import { PYRO_INPUTS, IMAGES, MACHINE } from "../mock";
import { ThermalFlow } from "./ThermalFlow";
import { AgroFlow } from "./AgroFlow";
import "./StoryPanels.css";

const ICONS = { Scissors, Wheat, Trees };
const H = 240;

export const Header = ({ tid }) => (
  <div className="process-header" data-testid={tid("pyro-header")}>
    <p className="label" data-testid={tid("pyro-label")}>Tecnología · Pirólisis</p>
    <h2 className="h-section mt-4" data-testid={tid("pyro-title")}>Calor de proceso sin gas, en la planta del cliente.</h2>
    <p className="text-muted mt-4" data-testid={tid("pyro-description")}><strong>Energía como servicio:</strong> Arlan instala y opera una unidad modular de pirólisis junto a las instalaciones del cliente. La biomasa residual se convierte en calor para el proceso y el carbono queda fijado en biochar, fuera de la atmósfera de forma permanente.</p>
  </div>
);

export const Inputs = ({ tid }) => (
  <div className="process-inputs" data-testid={tid("pyro-inputs")}>
    <div className="process-input-list">
      {PYRO_INPUTS.map((p, i) => {
        const Icon = ICONS[p.icon];
        return <div className="process-input" key={p.title} data-testid={tid(`pyro-input-${i}`)}>
          <Icon size={16} strokeWidth={1.4} aria-hidden="true" /><span>{p.title}</span>
        </div>;
      })}
    </div>
    <svg viewBox={`0 0 40 ${H}`} preserveAspectRatio="none" className="process-input-lines" aria-hidden="true">
      {[18, H / 2, H - 18].map(y => <path key={y} d={`M0 ${y} C22 ${y} 22 ${H / 2} 40 ${H / 2}`} stroke="var(--green-light)" strokeWidth="1.2" fill="none" className="flow-line" />)}
    </svg>
  </div>
);

// Dimension line runs parallel to the container's isometric base edge (image space 1163×765).
const DIM = { x1: 382, y1: 765, x2: 927, y2: 530, angle: -23.3 };

export const Machine = ({ tid }) => (
  <div className="process-machine" data-testid={tid("thermal-machine")}>
    <div className="process-machine-label" data-testid={tid("thermal-output-label")}>
      <span className="pulse-dot" aria-hidden="true" /><p><strong>Pirólisis</strong><span> · 500 °C · sin oxígeno</span></p>
    </div>
    <svg className="process-machine-figure" viewBox="0 0 1163 790" role="img" aria-label="Unidad de pirólisis Arlan con su longitud aproximada" data-testid={tid("machine-drawing")}>
      <image href={IMAGES.drawing} width="1163" height="765" />
      <g className="process-machine-dim" data-testid={tid("machine-dimension")} stroke="#b3b3b3" strokeWidth="2" fill="none">
        <line x1={DIM.x1} y1={DIM.y1} x2={DIM.x2} y2={DIM.y2} />
        <line x1={DIM.x1 - 6} y1={DIM.y1 - 14} x2={DIM.x1 + 6} y2={DIM.y1 + 14} />
        <line x1={DIM.x2 - 6} y1={DIM.y2 - 14} x2={DIM.x2 + 6} y2={DIM.y2 + 14} />
        <text x="684" y="704" transform={`rotate(${DIM.angle} 684 704)`} textAnchor="middle" fill="#d5d5d5" stroke="none" fontSize="32" letterSpacing="1">{MACHINE.dimension}</text>
      </g>
    </svg>
    <p className="process-machine-note" data-testid={tid("machine-note")}><Wrench size={13} strokeWidth={1.5} aria-hidden="true" />{MACHINE.operated}</p>
  </div>
);

// Header, inputs and machine stay fixed; only the outputs on the right crossfade.
export const PanelMachine = ({ agro, instanceId = "" }) => {
  const tid = name => instanceId ? `${name}-${instanceId}` : name;
  const layer = (on, children, name) => (
    <div className={`process-layer ${on ? "is-active" : ""}`} aria-hidden={!on} data-testid={tid(name)}>{children}</div>
  );
  return (
    <div className="process-panel" data-testid={tid("panel-energy")} data-phase={agro ? "agro" : "pyro"}>
      <div className="process-heading-stage"><Header tid={tid} /></div>
      <div className="process-grid">
        <div className="process-left"><Inputs tid={tid} /></div>
        <Machine tid={tid} />
        <div className="process-right">
          {layer(!agro, <ThermalFlow tid={tid} />, "pyro-output-layer")}
          {layer(agro, <AgroFlow tid={tid} />, "agro-flow-layer")}
        </div>
      </div>
    </div>
  );
};
